export const DEFAULT_ACTION_BUTTON_COLOR_CLASSES = 'bg-brand hover:!bg-brand text-on-brand'

// export const COLORS: string[] = [
//   'bg-[#fca5a5]',
//   'bg-[#fdba74]',
//   'bg-[#fcd34d]',
//   'bg-[#fde047]',
//   'bg-[#bef264]',
//   'bg-[#86efac]',
//   'bg-[#6ee7b7]',
//   'bg-[#5eead4]',
//   'bg-[#67e8f9]',
//   'bg-[#7dd3fc]',
//   'bg-[#93c5fd]',
//   'bg-[#a5b4fc]',
//   'bg-[#c4b5fd]',
//   'bg-[#d8b4fe]',
//   'bg-[#fda4af]'
// ]
// const hasCode = (s: string) =>
//   s.split('').reduce((a, b) => {
//     // eslint-disable-next-line no-bitwise
//     a = (a << 5) - a + b.charCodeAt(0)

//     // eslint-disable-next-line no-bitwise
//     return a & a
//   }, 0)

// function mod(n: number, m: number) {
//   return ((n % m) + m) % m
// }

// export const colorFromStr = (str: string) => {
//   const index = mod(hasCode(str), COLORS.length)

//   if (index >= 0 && index < COLORS.length) {
//     return COLORS[index]
//   }

//   return COLORS[0]
// }

// export const randomColor = () => COLORS[Math.floor(Math.random() * COLORS.length)]

// export const randomColorBySeedIndex = (index: number) => {
//   const remainder = index % COLORS.length

//   return COLORS[Math.floor(remainder)]
// }
